import React, { useEffect, useState, useContext } from 'react'


import { subscribe } from "../utils/pubsub"
import { GlobalContext } from '../GlobalContext'
import Button from '../formfields/Button'
import YellowAlert from '../ui-elements/YellowAlert'
import AutomaticReportSummary from './AutomaticReportSummary'


type Props = {
}

function AutomaticReportsList({
}: Props) {

  const {
    tableData,
    currentPortalId
  } = useContext(GlobalContext)


  const reports = tableData && currentPortalId && tableData.Portals && tableData.Portals[currentPortalId] && tableData.Portals[currentPortalId].AutomaticReports ? tableData.Portals[currentPortalId].AutomaticReports : {}

 

  return <div className={`w-full flex flex-col items-center`}>
    <div className={`max-w-3xl w-full p-4 flex flex-col gap-4 items-start justify-between`}>
      <div className={`w-full flex flex-row gap-4 justify-between items-center`}>
        <h3 className={`font-righteous text-3xl font-brandblue`}>Automatic reports</h3>
        <Button
          internalLinkUrl={`/automatic-report`}
          text={`Add new`}
          variant={`primary`}
          // size={`big`}
          fullwidth={false}
        />
      </div>

      {Object.keys(reports).length === 0 && <YellowAlert fullwidth={true}>No reports have been added yet.</YellowAlert>}

      {Object.keys(reports).length > 0 && <div className={`w-full flex flex-col gap-2`}>
        {Object.keys(reports).map((reportId) => {
          const report = reports[reportId]
          return <AutomaticReportSummary
            key={reportId}
            reportId={reportId}
            report={report}
          />
        })}
      </div>}
    </div>
  </div>
}

export default AutomaticReportsList